export const ROUTE_MAP = {
  orderList: '/ship/order/list',
  orderCreate: '/ship/order/create',
}
